module.exports = __webpack_public_path__ + "img/cicd-feature-3.615bbb7e.svg";